import React from "react";
import { useState, useEffect, useLayoutEffect } from "react";
import { EngLineChart } from "./EngLineChart";
import { EngBarChart } from "./EngBarChart";
import { FxmsData } from "../fxms/datas/FxData";
import { FxWindow } from "../fxms/windows/FxWindows";
import { red } from "@mui/material/colors";
import Modal from "@mui/material/Modal";
import Button from '@mui/material/Button'

import "./../css/VUP_dash.css";

export const EngInfo = (props) => {
  const [icon, setIcon] = React.useState("steam_icon001.png");
  const [data, setData] = useState([]);
  const [consInstVal, setConsInstVal] = useState(0);
  const [prodInstVal, setProdInstVal] = useState(0);
  const [totalConsInstVal, setTotalConsInstVal] = useState(0);
  const [totalProdInstVal, setTotalProdInstVal] = useState(0);
  const [currConsInstVal, setCurrConsInstVal] = useState(0);
  const [currProdInstVal, setCurrProdInstVal] = useState(0);
  const [remoteModal, setRemoteModal] = useState(false);
  const [remoteStatus, setRemoteStatus]  = useState("close");
  const [openDetailView, setOpenDetailView] = useState(false);
  const [currConsAmt, setCurrConsAmt] = useState(0);
  const [totalConsAmt, setTotalConsAmt] = useState(0);
  const energy = props.energy;
  const engId = props.engId;
  const complexInloNo = props.complexInloNo;
  const complexInloName = props.complexInloName;
  const dashId = props.dashId
  const isKepcoComplex = ["11000", "14000"].includes(String(complexInloNo));
  const isKepcoEpwr = isKepcoComplex && engId === "EPWR";
  const isNoAirComplex = String(complexInloNo) === "14000";
  const mainChartHeight = isNoAirComplex ? 235 : 180;
  const engUnitChart = {
    'prod': [
      {
        'engId': 'AIR', 'unit': 'Nm3/h'
      },
      {
        'engId': 'STEAM', 'unit': 'kg/h'
      },
      {
        'engId': 'EPWR', 'unit': 'kW'
      },
      {
        'engId': 'COOLWATER', 'unit': 'm3'
      }
    ],
    'cons': [
      {
        'engId': 'AIR', 'unit': 'Nm3/h'
      },
      {
        'engId': 'STEAM', 'unit': 'kg/h'
      },
      {
        'engId': 'EPWR', 'unit': 'kW'
      },
      {
        'engId': 'COOLWATER', 'unit': 'm3'
      }
    ]
  };
  const engUnitBar = {
    'prod': [
      {
        'engId': 'AIR', 'unit': 'Nm3'
      },
      {
        'engId': 'STEAM', 'unit': 'kg'
      },
      {
        'engId': 'EPWR', 'unit': 'kWh'
      },
      {
        'engId': 'COOLWATER', 'unit': 'm3'
      }
    ],
    'cons': [
      {
        'engId': 'AIR', 'unit': 'Nm3'
      },
      {
        'engId': 'STEAM', 'unit': 'kg'
      },
      {
        'engId': 'EPWR', 'unit': 'kWh'
      },
      {
        'engId': 'COOLWATER', 'unit': 'm3'
      }
    ]
  };

  //console.log("energy :: " + JSON.stringify(energy));

  const remotePopupClose = () => {
    setRemoteModal(false);
  };

  const handleRemoteStatusChange = (e) => {
    setRemoteStatus(e.target.value);
  }

  const onClickRemote= () =>{
    console.log("remoteStatus::" , remoteStatus);
    // todo: 실제 원격제어  api 호출

    //성공시
    //FxWindow.alert("밸브 제어가 실행되었습니다.", false);

    //실패시
    FxWindow.confirm("제어실패하였습니다.\n재시도 하시겠습니까?", function (bRet) {
      if (bRet === false) return;
      //재시도
    }); 

    //제어도중
    //FxWindow.alert("제어명령이 실행중입니다", true);    
   
  }

  const getIcon = (x) => {
    let icon = "steam_icon.png";
    if (x === "AIR") {
      icon = "air_icon.png";
    } else if (x === "COOLWATER") {
      icon = "water_icon.png";
    } else if (x === "STEAM") {
      icon = "steam_icon.png";
    } else if (x === "ELEC") {
      icon = "elec_icon001.png";
    } else if (x === "EPWR") {
      icon = "epwr_icon.png";
    }
    return "../" + icon;
  };

  const consInput = { complexInloNo: complexInloNo, engId: engId, startDate: getToday("yyyymmdd"), endDate: getToday("yyyymmdd") };

  const normalizeKepcoRows = (list = []) => {
    return list
      .map((row) => ({
        ...row,
        engId: row.engId || "EPWR",
        psDate: row.psDate || row.psdate,
        consAmt: parseFloat(
          row.consAmt ?? row.consamt ?? row.ACT_PW_AMT ?? 0
        ),
        consInstVal:
          parseFloat(
            row.consInstVal ??
            row.consinstval ??
            row.consAmt ??
            row.consamt ??
            row.ACT_PW_AMT ??
            0
          ),
      }))
      .sort((a, b) => Number(a.psDate || 0) - Number(b.psDate || 0));
  };

  async function inputKepcoData() {
    const uri = "vup/dash/energy/kepco";
    try {
      const res = await FxmsData.get(uri, {
        complexInloNo: complexInloNo,
        startDate: getToday("yyyymmdd"), // 당일만
        endDate: getToday("yyyymmdd"),
      });
      const rows = normalizeKepcoRows(res.data || []);
      const consSumKwh = rows.reduce(
        (prev, curr) => prev + ((parseFloat(curr.consAmt) || 0) * 0.25),
        0
      );
      const currItem = rows.length !== 0 ? rows[rows.length - 1] : {};
      const currCons = parseFloat(currItem.consAmt || 0);

      setData(rows);
      setConsInstVal(isNaN(consSumKwh) ? "No Data" : consSumKwh);
      setProdInstVal(0);
      setTotalProdInstVal(0);
      setCurrProdInstVal(0);
      setCurrConsInstVal(isNaN(currCons) ? "No Data" : currCons);
      setCurrConsAmt(isNaN(currCons) ? "No Data" : currCons);
      setTotalConsInstVal(isNaN(consSumKwh) ? "No Data" : consSumKwh);
      setTotalConsAmt(isNaN(consSumKwh) ? "No Data" : consSumKwh);
    } catch (e) {
      console.log(" kepco error e : " + e);
    }
  }

  function getToday(param) {
    //오늘날짜 가져오기 yyyymmdd | yyyymm | yyyy | mm
    var date = new Date();
    var year = date.getFullYear();
    var month = ("0" + (1 + date.getMonth())).slice(-2);
    var day = ("0" + date.getDate()).slice(-2);

    if (param === "yyyymmdd") {
      return year + month + day;
    } else if (param === "yyyymm") {
      return year + month;
    } else if (param === "yyyy") {
      return year;
    } else if (param === "mm") {
      return month;
    } else {
      return year + month + day;
    }
  }

  function getYesterday(dateString) {
    const year = dateString.substring(0, 4);
    const month = Number(dateString.substring(4, 6));
    const day = Number(dateString.substring(6, 8));

    const date = new Date(year, month - 1, day);
    date.setDate(date.getDate() - 1);

    const yearStr = date.getFullYear();
    const monthStr = ("0" + (date.getMonth() + 1)).slice(-2);
    const dayStr = ("0" + date.getDate()).slice(-2);
    return yearStr + monthStr + dayStr;
  }

  async function inputData() {
    const uri = "vup/dash/energy/list";
    try {
      const res = await FxmsData.get(uri, consInput);
      res.data.sort((a, b) => a.psDate - b.psDate);
      //console.log("res : " + JSON.stringify(res.data));

      let consAddValues = 0;
      let prodAddValues = 0;
      let currConsInstVal = res.data.length !==0? res.data.at(-1).consInstVal:undefined;
      let currProdInstVal = res.data.length !==0? res.data.at(-1).prodInstVal:undefined;
      let currConsAmt = res.data.length !==0? res.data.at(-1).consAmt:undefined;

      for (let val of res.data) {
        if (val.engId === engId || val.consInstVal !== null || val.prodInstVal !== null) {
          consAddValues += val.consAmt || 0;
          prodAddValues += val.prodAmt || 0;
        }
      }
      setData(res.data);
      setConsInstVal(
        isNaN(currConsInstVal) ? "No Data" : consAddValues
      );
      setProdInstVal(
        isNaN(currProdInstVal) ? "No Data" : prodAddValues
      );
      setCurrConsInstVal(
        isNaN(currConsInstVal) ? "No Data" : currConsInstVal
      );
      setCurrProdInstVal(
        isNaN(currProdInstVal) ? "No Data" : currProdInstVal
      );
      setCurrConsAmt(
        isNaN(currConsAmt) ? "No Data" : currConsAmt
      );
    } catch (e) {
      console.log(" error e : " + e);
    }
  }

  async function inputTotalData() {
    const uri = "vup/dash/energy/total";
    try {
      const res = await FxmsData.get(uri, consInput);
      res.data.sort((a, b) => a.psDate - b.psDate);
      //console.log("res : " + JSON.stringify(res.data));

      let consAddValues = 0;
      let prodAddValues = 0;
      let consAddAmt = 0;
      let currConsInstVal = res.data.length !==0? res.data.at(-1).consInstVal:undefined;
      let currProdInstVal = res.data.length !==0? res.data.at(-1).prodInstVal:undefined;
      let currConsAmt = res.data.length !==0? res.data.at(-1).consAmt:undefined;

      for (let val of res.data) {
        if (val.engId === engId || val.consInstVal !== null || val.prodInstVal !== null) {
          consAddValues += val.consAmt || 0;
          prodAddValues += val.prodAmt || 0;
          consAddAmt += val.consAmt || 0;
        }
      }

      setTotalConsInstVal(
        isNaN(currConsInstVal) ? "No Data" : consAddValues
      );
      setTotalProdInstVal(
        isNaN(currProdInstVal) ? "No Data" : prodAddValues
      );
      setTotalConsAmt(
        isNaN(currConsAmt) ? "No Data" : consAddAmt
      )
    } catch (e) {
      console.log(" error e : " + e);
    }
  }

  const filterData = energy.filter((obj) => obj.engId == engId);
  const chartUnitProd = engUnitChart.prod.filter((obj) => obj.engId === engId)[0].unit;
  const chartUnitCons = engUnitChart.cons.filter((obj) => obj.engId === engId)[0].unit;
  const barUnitProd = engUnitBar.prod.filter((obj) => obj.engId === engId)[0].unit;
  const barUnitCons = engUnitBar.cons.filter((obj) => obj.engId === engId)[0].unit;

  const engDescr = filterData.length > 0 ? filterData[0].engDescr : ""; // 에너지명
  const engUnitVal = filterData.length > 0 ? filterData[0].engUnit : ""; // 에너지단위

  // prod : 공급 cons : 사용
  // 여유율 : (1-(사용량/공급량))*100
  // 여유율 삭제
  let marginRate = "No Data";
  if (prodInstVal && prodInstVal > 0) {
    marginRate = ((1 - consInstVal / prodInstVal) * 100).toFixed(1) + "%";
  }

  // 시간 포맷팅 함수 수정
  const formatPsDate = (psDate) => {
    if (!psDate) return '';
    
    // psDate를 문자열로 변환
    const psDateStr = String(psDate);
    
    const year = psDateStr.substring(0, 4);
    const month = psDateStr.substring(4, 6);
    const day = psDateStr.substring(6, 8);
    const hour = psDateStr.substring(8, 10);
    const minute = psDateStr.substring(10, 12);
    
    return `${year}년 ${month}월 ${day}일 ${hour}:${minute} 기준`;
  };

  useEffect(() => {
    setIcon(getIcon(engId));
    if (isKepcoComplex && engId === "EPWR") {
      inputKepcoData();
    } else {
      inputData();
      inputTotalData();
    }
  }, []);

  /*useLayoutEffect(() => {
    const interval = setInterval(() => {
      inputData();
    }, 60000); // 1분마다 데이터를 가져오도록 설정

    return () => clearInterval(interval);
  }, []);*/

  return (
    <>
    {(complexInloNo=== 14000 && engId ==='AIR') ? 
      null:
      <><div className="gb_title mb20">
          <img src={icon} />
          {dashId === 'VupComDash' ? <>
            <h2
              id="dashPart h2"
              onClick={() => {
                setOpenDetailView(true);
              } }>
              {engDescr}
            </h2>
            <span style={{ fontSize: "10pt" }}></span></>
            :
            <h2
              id="dashPart h2"
              onClick={() => {
                setOpenDetailView(true);
              } }
            >
              {engDescr}
            </h2>}
          {openDetailView && (
            <Modal
              open={openDetailView}
              onClose={() => setOpenDetailView(false)}
              className="detail-chart-modal"
            >
              <div className="detail-chart-container">
                <div className="predict" style={{ height: '100%' }}>
                  <div className="vupNewLayerPop">
                    <div className="lpopTitle">
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '0 20px' }}>
                        <h3>{complexInloName} {engDescr} 상세 차트</h3>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                          <span style={{
                            fontSize: '13px',
                            color: '#999',
                            whiteSpace: 'nowrap',
                            marginRight: '100px'
                          }}>
                            {data.length > 0 && formatPsDate(data[data.length - 1].psDate)}
                          </span>
                          <div className="closeBtn" onClick={() => setOpenDetailView(false)}>
                            <img src="../svgCloseBtn_on.svg" />
                            <img src="../svgCloseBtn.svg" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="lpopContent detail-chart" style={{ height: 'calc(100% - 40px)' }}>
                      <EngLineChart
                        data={data}
                        engUnitValCons={chartUnitCons}
                        engUnitValProd={chartUnitProd}
                        isDetailView={true}
                        engId={engId}
                        isKepcoEpwr={isKepcoEpwr}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
          )}
          {remoteModal === true ? (
            <Modal
              open={true}
              onClose={remotePopupClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <div class="">
                <div class="predict">
                  <div class="vupNewLayerPop minSize">
                    <div class="lpopTitle">
                      <strong>{complexInloName} {engDescr} 밸브 제어</strong>
                      <div className="closeBtn" onClick={remotePopupClose}>
                        <img src="../svgCloseBtn_on.svg" />
                        <img src="../svgCloseBtn.svg" />
                      </div>
                    </div>
                    <div class="lpopContent">
                      <div class="inRadioGroup">
                        <p>
                          <input type="radio" value="open" onChange={handleRemoteStatusChange} checked={remoteStatus === "open"} /><label>열림</label>
                        </p>
                        <p>
                          <input type="radio" value="close" onChange={handleRemoteStatusChange} checked={remoteStatus === "close"} /><label>닫힘</label>
                        </p>
                      </div>
                    </div>
                    <div class="lpopBtn">
                      <Button onClick={onClickRemote} className="FxButton">확인</Button>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
          ) : null}
          {/* 전기 수요 순시값 */}
          {(engId === 'EPWR') && 
            <div className="fl_r fs12">
            {!isNaN(currConsAmt) &&          
               <>전력량: {currConsAmt > 0
                ? Math.round(currConsAmt).toLocaleString()
                : ""} <span className="unit">{currConsAmt ? "(" + chartUnitCons + ")" : "No data"}</span></>}{" "}
          </div>
          }
          {/* 압공,스팀 공급 순시값 */}
          {(engId === 'AIR' || engId === 'COOLWATER' || engId === 'STEAM') && 
            <div className="fl_r fs12">
            {!isNaN(currProdInstVal)&&              
               <>공급: {currProdInstVal > 0
                ? Math.round(currProdInstVal).toLocaleString()
                : ""} <span className="unit">{currProdInstVal ? "(" + chartUnitProd + ")" : "No data"}</span></>}{" "}
            <br />
            {/* 압공, 스팀 수요 순시값 */}
            {!isNaN(currConsInstVal) &&          
               <>수요: {currConsInstVal > 0
                ? Math.round(currConsInstVal).toLocaleString()
                : ""} <span className="unit">{currConsInstVal ? "(" + chartUnitCons + ")" : "No data"}</span></>}{" "}
          </div>
          }
          
          </div><div className="chartArea">
            <EngLineChart
              data={data}
              // engUnitVal={engUnitVal}
              engUnitValCons={chartUnitCons}
              engUnitValProd={chartUnitProd} 
              chartHeight={mainChartHeight}
              onDetailView={() => setOpenDetailView(true)}
              engId={engId}
              isKepcoEpwr={isKepcoEpwr}
            />
          </div><div>
            <ul class="noChartDataNew">
              {engId === 'EPWR' &&
                <>   
              {!isNaN(totalConsAmt) && <li>
                <b>전력량</b>
                <strong>
                  {parseInt(totalConsAmt).toLocaleString()}{barUnitCons}
                </strong>
              </li>}
                </>
              }
              {(engId === 'AIR' || engId === 'COOLWATER' || engId === 'STEAM') &&
                <>
                  {!isNaN(prodInstVal) && <li>
                    <b>공급</b>
                    <strong>
                      {parseInt(totalProdInstVal).toLocaleString()}{barUnitProd}
                    </strong>
                  </li>}
                  {!isNaN(consInstVal) && <li>
                    <b>수요</b>
                    <strong>
                      {parseInt(totalConsInstVal).toLocaleString()}{barUnitCons}
                    </strong>
                  </li>}
                </>
              }

            </ul>
          </div></>}
    </>
  );
};
